export const MY_REQUEST_TYPE = {
  LEAVE: "LEAVE",
  OFFSITE_WORK: "OFFSITE_WORK",
  REDEEM_TIME: "REDEEM_TIME",
  ENDORSE_TIME: "ENDORSE_TIME",
  OVERTIME: "OVERTIME",
  COLLECT_TIME: "COLLECT_TIME",
  DOCUMENT_REQUEST: "DOCUMENT_REQUEST",
  CHANGE_SHIFT: "CHANGE_SHIFT",
  WARNING_LETTER: "WARNING_LETTER",
  DETAIL: "DETAIL",
  APPROVALSEQ: "APPROVALSEQ",
  APPROVALREJECTSEQ: "APPROVALREJECTSEQ",
  EXPENSE: "EXPENSE"
};

export const MY_REQUEST_PAGE_LIST = Object.values(MY_REQUEST_TYPE);
